import Link from "next/link";
import { portalRoutes } from "@nju/routes";
import { A, Panel, Separator, Text } from "@nju/ui";
import { formatPhoneNumber, POSITIVE_DIGITS } from "@nju/utils";
import { Title } from "./partials";

interface IMsisdnSettingsProps {
  isActiveButton: boolean;
  isUnsubscribedOrDisconnected: boolean;
  clientNumber: string | undefined;
  userId: string | undefined;
  handlePushDataLayer: (eventName: string) => void;
}
export function MsisdnSettings({
  isUnsubscribedOrDisconnected,
  isActiveButton,
  clientNumber,
  userId,
  handlePushDataLayer,
}: IMsisdnSettingsProps) {
  return (
    <Panel testId="mobile-number-settings-panel">
      <Title iconName="mobile" title="ustawienia numeru" />
      <Text testId="client-number">
        {clientNumber &&
          formatPhoneNumber(clientNumber, POSITIVE_DIGITS, " ", "+48", true)}
      </Text>
      <Separator size="s" tone="invisible" />
      <div className="flex flex-col from-tablet:items-center gap-2 text-center">
        <Link
          className="block w-full"
          href={portalRoutes.mojeKonto.mojaKarta.ustawieniaNumeru.get({
            ...(userId && { userId }),
          })}
          passHref={true}
        >
          <A
            onClick={() => {
              handlePushDataLayer("NumberSettings");
            }}
            size={{
              "@onlyMobile": "s",
            }}
          >
            ustawienia
          </A>
        </Link>
        {!isActiveButton && !isUnsubscribedOrDisconnected && (
          <Link
            className="block w-full"
            href={portalRoutes.mojeKonto.mojaKarta.zmienNumer.get({
              ...(userId && { userId }),
            })}
            passHref={true}
          >
            <A
              onClick={() => {
                handlePushDataLayer("SIMCard");
              }}
              size={{
                "@onlyMobile": "s",
              }}
              testId="change-msisdn-button"
              variant="secondary"
            >
              zmień numer
            </A>
          </Link>
        )}
      </div>
    </Panel>
  );
}
